import { render, staticRenderFns } from "./lvsuo.vue?vue&type=template&id=c9920bfe&scoped=true"
import script from "./lvsuo.vue?vue&type=script&lang=js"
export * from "./lvsuo.vue?vue&type=script&lang=js"
import style0 from "./lvsuo.vue?vue&type=style&index=0&id=c9920bfe&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9920bfe",
  null
  
)

export default component.exports